import advanceAdressStatus from './advanceAdressStatus';

/**
 * Decide whether scheduling this task may auto-advance the linked address
 * to status "planned" (Ingepland). Only moves the status FORWARD — never
 * overwrites a further-along status like execute/follow-up/completed/
 * unreachable.
 *
 * "Forward" is derived from the funnel order instead of a hardcoded list of
 * statuses. That list used to be `['planning']` only, so when 'awaiting'
 * ('In afwachting') was inserted between planning and planned, a household
 * you had called and then scheduled a visit for silently stayed on
 * 'In afwachting' — which is exactly the path the tenant described.
 *
 * AI-CONTEXT: See docs/pitfalls.md#state-handler-overwrites-sibling-field
 * AI-CONTEXT: See docs/pitfalls.md#dev-copied-recipe-instead-of-shared-hook
 *
 * @param {object|null|undefined} task - Task document (Type, AdressID, Timestamp)
 * @param {string|null|undefined} currentStatus - Current Adresses.Status value
 * @returns {boolean}
 */
const shouldAutoMarkPlanned = (task, currentStatus) =>
    advanceAdressStatus(task, currentStatus, 'planned');

export default shouldAutoMarkPlanned;
